import {httpGet} from "../libs/http";

export const unsubscribeEmail = (id, onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/account/unsubscribe/?eid=' + id, (res) => onSuccess(res), (err) => onFailure(err));
};